import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import MD5 from "crypto-js/md5";
import './Dashboard.css';
import useAuth from './useAuth';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const Dashboard = () => {
     useAuth();
     const [items, setItems] = useState([]);
     const [loading, setLoading] = useState(true);
     const [error, setError] = useState('');
     const navigate = useNavigate();
     const openedTabs = [];
     const { hostname, port } = window.location;

     const ot = (hostname === '183.82.10.144' && port === '40407')
          ? 'http://183.82.10.144:40407/ot/index2.php'
          : 'http://10.0.4.112:40407/ot/index2.php';

     const ot1 = (hostname === '183.82.10.144' && port === '40407')
          ? 'http://183.82.10.144:40407/ot/index_new.php'
          : 'http://10.0.4.112:40407/ot/index_new.php';
     // const token = sessionStorage.getItem('authToken1');
     // console.log("check",token);
     //     if (!token) {
     //       navigate('/');
     //     }
     const handleLogout = async () => {
          try {
               const token = localStorage.getItem('authToken');
               const response = await fetch(`${API_BASE_URL}central_logout`, {
                    method: 'POST',
                    headers: {
                         'Authorization': `Bearer ${token}`
                    }
               });

               const result = await response.json();
               if (result.status) {
                    // Close opened tabs
                    openedTabs.forEach(tab => {
                         if (tab && !tab.closed) {
                              tab.close();
                         }
                    });

                    localStorage.removeItem('authToken');
                    sessionStorage.removeItem('authToken1');
                    localStorage.removeItem('exp');
                    navigate('/');
               }
          } catch (error) {
               console.error('Logout error:', error);
          }
     };


     const openApp = (url) => {
          const newTab = window.open(url, '_blank');
          if (newTab) {
               openedTabs.push(newTab); // Store reference
          } else {
               alert("Popup blocked! Please allow popups for this site.");
          }
     };


     useEffect(() => {
          const fetchItems = async () => {
               try {
                    const response = await fetch('https://central.vdcapp.in/admin/api/announcements', {
                         method: 'GET',
                         headers: {
                              'Content-Type': 'application/json'
                         }
                    });

                    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
                    const result = await response.json();
                    if (result.status) setItems(result.data);
                    else setError(result.message);
               } catch (error) {
                    console.error('Fetch error:', error);
                    setError('Failed to fetch items');
               } finally {
                    setLoading(false);
               }
          };

          fetchItems();
     }, [navigate]);


     const emp_code = localStorage.getItem('emp_code');
     const emp_password = localStorage.getItem('emp_password');
     const emp_password1 = sessionStorage.getItem('emp_password1');

     const emp_password_mms = localStorage.getItem('emp_password_mms');


     //alert(emp_password);

     const encodedEmpCode = btoa(emp_code || '');
     const encodedPassword = btoa(emp_password || '');

     const otApiUrl = `${ot1}?uid=${encodedEmpCode}&mms_password=${emp_password_mms}&pwd=${encodedPassword}`;
     const ticketingURL = `https://support.vijayadiagnostic.in/portal/en/signin`;
     const osbURL = `https://osb.vdcapp.in/login_suc1.php?uid=${encodedEmpCode}&pwd=${encodedPassword}&mms_password=${emp_password_mms}&type=c`;
     const info_vdcURL = `https://info.vdcapp.in/login1?uid=${encodedEmpCode}`;
     //const reminderurl = `https://reminder.vdcapp.in/backend/api/login1?uid=${encodedEmpCode}&pwd=${encodedPassword}`;

     // const reminderApiUrl = `https://reminder.vdcapp.in/login1?uid=${encodedEmpCode}&pwd=${emp_password1}&mms_password=${emp_password_mms}&type=c`;

     const reminderApiUrl = (() => {
          // Use current user's credentials (same pattern as other apps)
          const currentEmpCode = emp_code || '';
          const currentPassword = emp_password1 || emp_password || '';
          const currentMms = emp_password_mms || '';

          // Encode them properly
          const encodedUid = btoa(currentEmpCode);
          const encodedPwd = btoa(currentPassword);
          const encodedMms = btoa(currentMms);

          console.log('Reminder URL generated for user:', { empCode: currentEmpCode, hasPassword: !!currentPassword });

          return `https://reminder.vdcapp.in/login1?uid=${encodedUid}&pwd=${encodedPwd}&mms_password=${encodedMms}&type=c`;
     })();
     let travelApiUrl = '';

     if (encodedPassword) {
          travelApiUrl = `https://travelapp.vdcapp.in/login1?uid=${encodedEmpCode}&pwd=${emp_password1}&mms_password=${emp_password_mms}&type=c`;
     } else if (emp_password1) {
          // const fallbackEncodedPassword = btoa(emp_password1);
          travelApiUrl = `https://travelapp.vdcapp.in/login2?uid=${encodedEmpCode}&pwd=${emp_password1}&mms_password=${emp_password_mms}&type=c`;
     }
     let checklistApiUrl = '';
     if (encodedPassword) {
          checklistApiUrl = `https://checklist.vdcapp.in/login1?uid=${encodedEmpCode}&pwd=${emp_password1}&mms_password=${emp_password_mms}&type=c`;
     } else if (emp_password1) {
          // const fallbackEncodedPassword = btoa(emp_password1);
          checklistApiUrl = `https://checklist.vdcapp.in/login2?uid=${encodedEmpCode}&pwd=${emp_password1}&mms_password=${emp_password_mms}&type=c`;
     }
     //const checklistApiUrl = `https://checklist.vdcapp.in/login1?uid=${encodedEmpCode}&pwd=${encodedPassword}&mms_password=${emp_password_mms}&type=c`;
     const uniformApiUrl = `https://uniform.vdcapp.in/login1?uid=${encodedEmpCode}&pwd=${emp_password1}&mms_password=${emp_password_mms}&type=c`;
     const randrApiUrl = `https://randr.vdcapp.in/login1?uid=${encodedEmpCode}&pwd=${emp_password1}&mms_password=${emp_password_mms}&type=c`;
     const dmgURL = `https://dmg.vdcapp.in/index3.php?uid=${encodedEmpCode}&pwd=${emp_password1}&mms_password=${emp_password_mms}&type=c`;
     const phURL = `https://hr.vdcapp.in/login/Login_Auth1?uid=${encodedEmpCode}&pwd=${emp_password1}&mms_password=${emp_password_mms}&type=c`;
     const qrURL = `https://qr.vdcapp.in/`;
     const petctApiUrl = `https://petct.vdcapp.in/login1?uid=${encodedEmpCode}&pwd=${emp_password1}`;
     const hrmsApiUrl = `https://internalhrms.vdcapp.in/login1?uid=${encodedEmpCode}&pwd=${emp_password1}`;

     // const hrmsApiUrl = `http://localhost:3001/login1?uid=${encodedEmpCode}&pwd=${emp_password1}`;

     const marqueeRef = useRef(null);

     const handleMouseOver = () => {
          marqueeRef.current?.stop();
     };

     const handleMouseOut = () => {
          marqueeRef.current?.start();
     };


     return (
          <div className="d-flex flex-column">
               {/* HEADER */}
               <header id="header" className="header sticky-top">
                    <div className="topbar">
                         <div className="container d-flex justify-content-between align-items-center flex-wrap py-2">
                              <a className="logo d-flex align-items-center">
                                   <img src="assets/img/logo1.png" alt="Logo" style={{ height: '60px' }} />
                              </a>
                              <div className="d-flex align-items-center">
                                   <i className="bi bi-phone me-1"></i> {localStorage.getItem('comp_name')}
                              </div>
                              <button
                                   onClick={handleLogout}
                                   className="btn btn-outline-dark d-flex align-items-center"
                              >
                                   <i className="bi bi-box-arrow-right me-2"></i> Sign Out
                              </button>

                         </div>
                    </div>

                    <div className="text-center my-3">
                         <h3 className="shadow-text" style={{ color: '#C78284' }}>CENTRALIZED DASHBOARD</h3>
                    </div>


               </header>

               {/* MAIN */}
               <main className="flex-grow-1 container-fluid px-3">
                    <div className="row">
                         <div className="col-lg-9">
                              <div className="row">

                                   <div className="row mt-4">
                                        <div className="col-md-2 mb-3">
                                             <div onClick={() => openApp(info_vdcURL)} style={{ textDecoration: 'none', cursor: 'pointer' }}>
                                                  <div className="icon-title-description">
                                                       <div className="icon">
                                                            <img src="assets/img/branch_info_icon.png" alt="Augmento" />
                                                       </div>
                                                       <div className="title"><h2>VDC APP</h2></div>
                                                       <div className="description"><small>Branch Information</small></div>
                                                  </div>
                                             </div>
                                        </div>

                                        <div className="col-md-2 mb-3">
                                             <div onClick={() => openApp(travelApiUrl)} style={{ textDecoration: 'none', cursor: 'pointer' }}>
                                                  <div className="icon-title-description">
                                                       <div className="icon">
                                                            <img src="assets/img/travel_icon.png" alt="Focus" />
                                                       </div>
                                                       <div className="title"><h2>Travel App</h2></div>
                                                       <div className="description"><small>Tour And Travel</small></div>
                                                  </div>
                                             </div>
                                        </div>



                                        <div className="col-md-2 mb-3">

                                             <div onClick={() => openApp(checklistApiUrl)} style={{ textDecoration: 'none', cursor: 'pointer' }}>
                                                  <div className="icon-title-description">
                                                       <div className="icon">
                                                            <img src="assets/img/checklist.jpg" alt="Augmento" />
                                                       </div>
                                                       <div className="title"><h2>Check List</h2></div>
                                                       <div className="description"><small>BM CM Check List</small></div>
                                                  </div>
                                             </div>
                                        </div>


                                        <div className="col-md-2 mb-3">
                                             <div
                                                  onClick={sessionStorage.getItem('is_ticket') === 'Y' ? () => openApp(ticketingURL) : null}
                                                  style={{
                                                       textDecoration: 'none',
                                                       cursor: sessionStorage.getItem('is_ticket') === 'Y' ? 'pointer' : 'not-allowed'
                                                  }}
                                                  title={sessionStorage.getItem('is_ticket') === 'Y' ? '' : 'You are not authorized to use this application please contact IT Dept to use this application please contact IT Dept'}
                                             >

                                                  <div className="icon-title-description">
                                                       <div className="icon">
                                                            <center><img src="assets/img/ticket.png" alt="Card image 1" style = {{width:"70px"}}/></center>
                                                       </div>
                                                       
                                                       <div className="title"><h2>Ticketing</h2></div>
                                                       
                                                       <div className="description"><small>Ticketing Tool</small></div>
                                                  </div>
                                             </div>
                                        </div>

                                        {/* <div className="col-md-2 mb-3"> */}
                                             {/* <div
                                                  onClick={sessionStorage.getItem('is_uniform_access_given') === 'Y' ? () => openApp(uniformApiUrl) : null}
                                                  style={{
                                                       textDecoration: 'none',
                                                       cursor: sessionStorage.getItem('is_uniform_access_given') === 'Y' ? 'pointer' : 'not-allowed'
                                                  }}
                                                  title={sessionStorage.getItem('is_uniform_access_given') === 'Y' ? '' : 'You are not authorized to use this application please contact IT Dept to use this application please contact IT Dept'}
                                             > */}

                                                  {/* <div className="icon-title-description">
                                                       <div className="icon"><img src="assets/img/uniform.jpg" alt="Focus" /></div>
                                                       <div className="title"><h2>Uniform</h2></div>
                                                       <div className="description"><small>Uniform System</small></div>
                                                  </div> */}
                                             {/* </div> */}
                                        {/* </div> */}

                                        <div className="col-md-2 mb-3">

                                             <div
                                                  onClick={sessionStorage.getItem('is_randr') === 'Y' ? () => openApp(randrApiUrl) : null}
                                                  style={{
                                                       textDecoration: 'none',
                                                       cursor: sessionStorage.getItem('is_randr') === 'Y' ? 'pointer' : 'not-allowed'
                                                  }}
                                                  title={sessionStorage.getItem('is_randr') === 'Y' ? '' : 'You are not authorized to use this application please contact IT Dept to use this application please contact IT Dept'}
                                             >
                                                  <div className="icon-title-description">
                                                       <div className="icon"><center><img src="assets/img/rewards.png" alt="Card image 1" style={{ width: "33%" }} /></center></div>
                                                       <div className="title"><h2><center>R&R</center></h2></div>
                                                       <div className="description"><small>Rewards & Recognition</small></div>
                                                  </div>
                                             </div>
                                        </div>

                                        <div className="col-md-2 mb-3">
                                             <div
                                                  onClick={sessionStorage.getItem('is_ot') === 'Y' ? () => openApp(otApiUrl) : null}
                                                  style={{
                                                       textDecoration: 'none',
                                                       cursor: sessionStorage.getItem('is_ot') === 'Y' ? 'pointer' : 'not-allowed'
                                                  }}
                                                  title={sessionStorage.getItem('is_ot') === 'Y' ? '' : 'You are not authorized to use this application please contact IT Dept to use this application please contact IT Dept to use this application please contact IT Dept'}
                                             >

                                                  <div className="icon-title-description">
                                                       <div className="icon"><img src="assets/img/overtime_icon.png" alt="VDC OT Icon" /></div>
                                                       <div className="title"><h2>VDC OT</h2></div>
                                                       <div className="description"><small>Overtime</small></div>
                                                  </div>
                                             </div>
                                        </div>

                                        <div className="col-md-2 mb-3">
                                             <div
                                                  onClick={sessionStorage.getItem('is_osb') === 'Y' ? () => openApp(osbURL) : null}
                                                  style={{
                                                       textDecoration: 'none',
                                                       cursor: sessionStorage.getItem('is_osb') === 'Y' ? 'pointer' : 'not-allowed'
                                                  }}
                                                  title={sessionStorage.getItem('is_osb') === 'Y' ? '' : 'You are not authorized to use this application please contact IT Dept to use this application please contact IT Dept to use this application please contact IT Dept'}
                                             >

                                                  <div className="icon-title-description">
                                                       <div className="icon"><img src="assets/img/osb.png" alt="Focus" /></div>
                                                       <div className="title"><h2>OSB</h2></div>
                                                       <div className="description"><small>Outsourcing</small></div>
                                                  </div>
                                             </div>
                                        </div>

                                        <div className="col-md-2 mb-3">
                                             <div onClick={() => openApp(reminderApiUrl)} style={{ textDecoration: 'none', cursor: 'pointer' }}>
                                                  <div className="icon-title-description">
                                                       <div className="icon">
                                                            <img src="assets/img/remainder.jpg" alt="Augmento"  style = {{width:"70px"}}/>
                                                       </div>
                                                       <div className="title"><h2>Reminder</h2></div>
                                                       <div className="description"><small>Reminder</small></div>
                                                  </div>
                                             </div>
                                        </div>

                                        <div className="col-md-2 mb-3">
                                             <div
                                                  onClick={sessionStorage.getItem('is_dmg') === 'Y' ? () => openApp(dmgURL) : null}
                                                  style={{
                                                       textDecoration: 'none',
                                                       cursor: sessionStorage.getItem('is_dmg') === 'Y' ? 'pointer' : 'not-allowed'
                                                  }}
                                                  title={sessionStorage.getItem('is_dmg') === 'Y' ? '' : 'You are not authorized to use this application please contact IT Dept to use this application please contact IT Dept'}
                                             >
                                                  <div className="icon-title-description">
                                                       <div className="icon"><img src="assets/img/dmg_icon.png" alt="Focus" /></div>
                                                       <div className="title"><h2>DMG</h2></div>
                                                       <div className="description"><small>Direct marketing</small></div>
                                                  </div>
                                             </div>
                                        </div>

                                        {/* <div className="col-md-2 mb-3"> */}
                                        {/* <div
                                                  onClick={sessionStorage.getItem('is_phhr') === 'Y' ? () => openApp(phURL) : null}
                                                  style={{
                                                       textDecoration: 'none',
                                                       cursor: sessionStorage.getItem('is_phhr') === 'Y' ? 'pointer' : 'not-allowed'
                                                  }}
                                                  title={sessionStorage.getItem('is_phhr') === 'Y' ? '' : 'You are not authorized to use this application please contact IT Dept to use this application please contact IT Dept'}
                                             > */}
                                        {/* <div className="icon-title-description">
                                                       <div className="icon"><img src="assets/img/hr.png" alt="Focus" /></div>
                                                       <div className="title"><h2>PH HR</h2></div>
                                                       <div className="description"><small>PH HR</small></div> */}
                                        {/* </div>
                                             </div>
                                        </div> */}

                                        <div className="col-md-2 mb-3">
                                             <div
                                                  onClick={() => openApp(qrURL)}>
                                                  <div className="icon-title-description">
                                                       <div className="icon"><img src="assets/img/qr.png" alt="Focus" /></div>
                                                       <div className="title"><h2>QR</h2></div>
                                                       <div className="description"><small>QR App</small></div>
                                                  </div>
                                             </div>
                                        </div>

                                        {/* <div className="col-md-2 mb-3">
                                             <div onClick={() => openApp(petctApiUrl)} style={{ textDecoration: 'none', cursor: 'pointer' }}>
                                                  <div className="icon-title-description">
                                                       <div className="icon">
                                                            <img src="assets/img/petct.png" alt="Augmento" />
                                                       </div>
                                                       <div className="title"><h2>Petct</h2></div>
                                                       <div className="description"><small>Petct</small></div>
                                                  </div>
                                             </div>
                                        </div> */}

                                        <div className="col-md-2 mb-3">
                                             <div onClick={() => openApp(hrmsApiUrl)} style={{ textDecoration: 'none', cursor: 'pointer' }}>
                                                  <div className="icon-title-description">
                                                       <div className="icon">
                                                            <img src="assets/img/hrms.jpg" alt="Augmento"  />
                                                       </div>
                                                       <div className="title"><h2>HRMS</h2></div>
                                                       <div className="description"><small>HRMS</small></div>
                                                  </div>
                                             </div>
                                        </div>

                                        {/* <div className="col-md-2 mb-3">
                                             <div onClick={() => openApp('https://support.vijayadiagnostic.in')} style={{ textDecoration: 'none', cursor: 'pointer' }}>
                                                  <div className="icon-title-description">
                                                       <div className="icon">
                                                            <img src="assets/img/support_icon.png" alt="Support" style = {{width:"39px"}}/>
                                                       </div>
                                                       <div className="title"><h2>Support</h2></div>
                                                       <div className="description"><small>Helpdesk Portal</small></div>
                                                  </div>
                                             </div>
                                        </div> */}
                                   </div>
                              </div>
                         </div>

                         {/* <div className="col-md-3">
                              <div className="announcements-notifications" style={{ height: "500px" }} >
                                   <b><center>Announcements</center></b>
                                   <br />
                                   <marquee width="100%" direction="up" height="400px"  >
                                        Welcome to Our Website! 🌟 Stay Updated with the Latest News and Offers. 📢 Check Back Often for More Updates!
                                        {loading && <small>Loading...</small>}
                                        {error && <small className="error">{error}</small>}
                                        {!loading && !error && items.length === 0 && <small>No announcements available.</small>}
                                        {!loading && !error && items.length > 0 && items.map((item, index) => (
                                             <div key={index} className="notification-item">
                                                  <h4>{item.title}</h4>
                                                  <small>{item.description}</small>
                                             </div>
                                        ))}

                                   </marquee>
                              </div>
                         </div> */}

                         <div className="col-md-3">
                              <div className="announcements-notifications" style={{ height: "500px" }} >
                                   <b><center>Announcements</center></b>
                                   <br />
                                   <marquee
                                        ref={marqueeRef}
                                        width="100%"
                                        direction="up"
                                        height="400px"
                                        onMouseOver={handleMouseOver}
                                        onMouseOut={handleMouseOut}
                                   >
                                        Welcome to Our Website! 🌟 Stay Updated with the Latest News and Offers. 📢 Check Back Often for More Updates!
                                        {loading && <small>Loading...</small>}
                                        {error && <small className="error">{error}</small>}
                                        {!loading && !error && items.length === 0 && <small>No announcements available.</small>}
                                        {!loading && !error && items.length > 0 && items.map((item, index) => (
                                             <div key={index} className="notification-item">
                                                  <h4>{item.title}</h4>
                                                  <small>{item.description}</small>
                                             </div>
                                        ))}
                                   </marquee>
                              </div>
                         </div>

                    </div>
               </main>

               {/* FOOTER */}
               <footer id="footer" className="footer bg-light py-4">
    <div className="container text-center">
        <small>
            <strong>For Support:</strong>{" "}
            <a href="mailto:it@vijayadiagnostic.in">
                it@vijayadiagnostic.in
            </a>
        </small>
        <br />
        <small>
            &copy; {new Date().getFullYear()}{" "}
            <strong className="sitename px-1">
                Vijaya Diagnostic Centre Limited
            </strong>
            All Rights Reserved
        </small>
    </div>
</footer>
          </div>
     );
};

export default Dashboard;
